import PropTypes from 'prop-types'

import { usePrevious } from 'hooks/usePrevious'

export const AnimatedFrame = ({ as: Frame = 'div', children, id, ...rest }) => {
  const previousId = usePrevious(id)
  const previousChildren = usePrevious(children)

  const isAnimating = previousId && previousId !== id
  const direction = previousId && id > previousId ? 'rtl' : 'ltr'

  return (
    <>
      {isAnimating && (
        <Frame
          key={previousId}
          isAnimating
          animationTarget="out"
          animationDirection={direction}
          {...rest}
        >
          {previousChildren}
        </Frame>
      )}
      <Frame
        key={id}
        isAnimating={isAnimating}
        animationTarget="in"
        animationDirection={direction}
        {...rest}
      >
        {children}
      </Frame>
    </>
  )
}

AnimatedFrame.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  id: PropTypes.number.isRequired
}
